import ListRaterInvite from "components/Participant/RatersInvite/List/List"
import React from "react"

const ListRaterInvitePage = () => {
    return (
        <React.Fragment>
            <ListRaterInvite />
        </React.Fragment>
    )
}
export default ListRaterInvitePage
